import { MainLayout } from "@/layouts/MainLayout";
import { AnimatedSection } from "@/components/AnimatedSection";
import { ContatoMultiStepForm } from "@/components/contato/ContatoMultiStepForm";

const Contato = () => {
  return (
    <MainLayout>
      {/* Hero */}
      <section className="section-padding">
        <div className="container-wide">
          <div className="grid lg:grid-cols-2 gap-16 items-start">
            {/* Left column - Text */}
            <div>
              <AnimatedSection>
                <span className="label-sm text-primary mb-4 block">Fale Conosco</span>
                <h1 className="heading-xl mb-6">
                  Uma conversa pode trazer mais clareza do que um{" "}
                  <span className="text-primary">produto.</span>
                </h1>
              </AnimatedSection>
              
              <AnimatedSection delay={0.1}>
                <p className="body-lg mb-8">
                  Se você sente falta de uma visão integrada do seu patrimônio ou 
                  precisa de apoio em decisões relevantes, estamos aqui para conversar.
                </p>
              </AnimatedSection>

              <AnimatedSection delay={0.2}>
                <div className="surface-card p-6 mb-6">
                  <h3 className="font-sans font-medium text-foreground mb-2">
                    O que esperar da conversa inicial?
                  </h3>
                  <ul className="space-y-2 text-muted-foreground">
                    <li className="flex items-start gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-primary mt-2" />
                      Entendimento do seu contexto patrimonial
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-primary mt-2" />
                      Avaliação das suas necessidades
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-primary mt-2" />
                      Explicação do nosso modelo de atuação
                    </li>
                    <li className="flex items-start gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-primary mt-2" />
                      Sem compromisso, sem venda de produtos
                    </li>
                  </ul>
                </div>
              </AnimatedSection>
            </div>

            {/* Right column - Form */}
            <AnimatedSection delay={0.2}>
              <ContatoMultiStepForm />
            </AnimatedSection>
          </div>
        </div>
      </section>
    </MainLayout>
  );
};

export default Contato;
